module.exports = __webpack_public_path__ + "static/img/zhuanli-1.130c8170.png";